import { writable, type Writable } from "svelte/store";

export type ErrorMessage = {
  title: string;
  message: string;
};

export const error: Writable<ErrorMessage | null> = writable(null);

export function clearError() {
  error.set(null);
}

export function logError(reason: ErrorMessage) {
  error.set(reason);
}

export const ERRORS: { [key: string]: { [type: string]: ErrorMessage } } = {
  geolocation: {
    outside: {
      title: "Are you here?",
      message:
        "It looks like you may be located outside of this map, so we can't show your location at this time"
    },
    unsupported: {
      title: "We couldn't find you",
      message: "Geolocation is unsupported by your device."
    },
    permission_denied: {
      title: "Geolocation access denied",
      message: "Please check your browser settings and try again."
    },
    unavailable: {
      title: "We couldn't find you",
      message: "There was an issue communicating with your GPS. Please try again."
    },
    timeout: {
      title: "We couldn't find you",
      message: `We stopped trying to find your location after not getting an answer for a while. Please try again.`
    },
    general: {
      title: "We couldn't find you",
      message: "It looks like we had an issue finding you. Please try again."
    }
  }
};
